import gql from "graphql-tag";

export const ADD_EQUIPMENT = gql`
  mutation addEquipment($where: EquipmentManagementInput!) {
    addEquipment(where: $where)
  }
`;